// Auto-extracted from SellerAnalytics.jsx
import { C } from "../../lib/theme";
import { Card } from "../../components/Card";
import { Icon } from "../../components/Icon";
import { fmtK, fmtKShort } from "../../lib/money";
import { resolveImage } from "../../lib/images";

export function TopProductsChart({ products }) {
  const maxRev = Math.max(1, ...products.map((p) => p.revenue));
  return (
    <div style={{ display: "grid", gap: 10 }}>
      {products.map((p) => {
        const img = resolveImage(p.images, "thumb");
        const widthPct = (p.revenue / maxRev) * 100;
        return (
          <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 8,
                overflow: "hidden",
                background: C.cream,
                flexShrink: 0,
              }}
            >
              {img && <img src={img} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                  marginBottom: 4,
                  gap: 8,
                }}
              >
                <div
                  style={{
                    fontSize: 12.5,
                    fontWeight: 800,
                    color: C.charcoal,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {p.title}
                </div>
                <div style={{ fontSize: 12.5, fontWeight: 800, color: C.hunter, whiteSpace: "nowrap" }}>
                  {fmtK(p.revenue)}
                </div>
              </div>
              <div style={{ height: 6, background: C.cream, borderRadius: 3, overflow: "hidden" }}>
                <div
                  style={{
                    width: `${widthPct}%`,
                    height: "100%",
                    background: `linear-gradient(90deg, ${C.hunter}, ${C.hunterLt})`,
                    borderRadius: 3,
                  }}
                />
              </div>
              <div style={{ fontSize: 10.5, color: C.muted, marginTop: 3 }}>{p.units} units</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
